module.exports = __webpack_public_path__ + "img/arrows-collapse.8b12c437.svg";